"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.UpdateSlugDto = void 0;
var class_validator_1 = require("class-validator");
var interfaces_1 = require("../interfaces");
var UpdateSlugDto = (function () {
    function UpdateSlugDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], UpdateSlugDto.prototype, "isActive");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsIn(Object.keys(interfaces_1.SLUG_HREF_TYPES)),
        __metadata("design:type", String)
    ], UpdateSlugDto.prototype, "type");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UpdateSlugDto.prototype, "href");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateIf(function (obj) { return obj.type === interfaces_1.SLUG_HREF_TYPES.HOTELS_LIST; }),
        class_validator_1.IsIn(Object.keys(interfaces_1.LIST_PAGE_TYPES)),
        __metadata("design:type", String)
    ], UpdateSlugDto.prototype, "listPageType");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateIf(function (obj) { return obj.type === interfaces_1.SLUG_HREF_TYPES.HOTEL; }),
        __metadata("design:type", String)
    ], UpdateSlugDto.prototype, "hotel");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateIf(function (obj) { return obj.type === interfaces_1.SLUG_HREF_TYPES.HOTELS_LIST; }),
        __metadata("design:type", Array)
    ], UpdateSlugDto.prototype, "hotelsList");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateIf(function (obj) { return obj.type === interfaces_1.SLUG_HREF_TYPES.HOTELS_LIST && obj.listPageType === interfaces_1.LIST_PAGE_TYPES.PLACE; }),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], UpdateSlugDto.prototype, "country");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateIf(function (obj) { return obj.type === interfaces_1.SLUG_HREF_TYPES.HOTELS_LIST && obj.listPageType === interfaces_1.LIST_PAGE_TYPES.PLACE; }),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], UpdateSlugDto.prototype, "province");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateIf(function (obj) { return obj.type === interfaces_1.SLUG_HREF_TYPES.HOTELS_LIST && obj.listPageType === interfaces_1.LIST_PAGE_TYPES.PLACE; }),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], UpdateSlugDto.prototype, "district");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateIf(function (obj) { return obj.type === interfaces_1.SLUG_HREF_TYPES.STATIC; }),
        class_validator_1.IsObject(),
        __metadata("design:type", Object)
    ], UpdateSlugDto.prototype, "title");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateIf(function (obj) { return obj.type === interfaces_1.SLUG_HREF_TYPES.STATIC; }),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], UpdateSlugDto.prototype, "footer");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateIf(function (obj) { return obj.type === interfaces_1.SLUG_HREF_TYPES.STATIC; }),
        class_validator_1.IsObject(),
        __metadata("design:type", Object)
    ], UpdateSlugDto.prototype, "content");
    return UpdateSlugDto;
}());
exports.UpdateSlugDto = UpdateSlugDto;
//# sourceMappingURL=update-slug.dto.js.map